import { Validator } from "../validator"

export enum PostalCodeError {
    INVALID = `errors.invalid_postal_code`,
}

const ALL_SAME_DIGITS = /^([0-9])\1{5}$/
const DIGITS_ONLY = /^[0-9]+$/
const MAX = 6
class PostalCodeValidator implements Validator<string, PostalCodeError> {
    validate(entry: string): PostalCodeError | undefined {
        const value = entry.trim()

        if (value === `` || !DIGITS_ONLY.test(value) || ALL_SAME_DIGITS.test(value) || value.length < MAX ) {
            return PostalCodeError.INVALID
        }
        return undefined

    }
}

export { PostalCodeValidator }